import React, { useState } from "react";
import { getBaseCoin } from "../utils/upDownFormatters";

export const CoinIcon = ({ symbol }) => {
  const base = getBaseCoin(symbol).toLowerCase();
  const [error, setError] = useState(false);

  return (
    <div className="w-5 h-5 flex items-center justify-center rounded-full overflow-hidden shrink-0 bg-white/10 border border-white/15">
      {!error ? (
        <img
          src={`https://cdn.jsdelivr.net/gh/spothq/cryptocurrency-icons@master/128/color/${base}.png`}
          alt={base}
          className="w-full h-full object-cover"
          onError={() => setError(true)}
        />
      ) : (
        <span className="text-[10px] font-bold text-white uppercase">{base?.[0] || "?"}</span>
      )}
    </div>
  );
};

